import React from 'react'
import { deviceDetect } from 'Modules'
import { useSelector } from 'react-redux'
import { DesktopUserRoutes } from 'Pages/user/routes/desktopRoutes'
import { MobileUserRoutes } from 'Pages/user/routes/mobileRoutes'

export const UserRoutes = () => {
	const isMobile = useSelector(deviceDetect.getIsMobile)

	return <>{isMobile ? <MobileUserRoutes /> : <DesktopUserRoutes />}</>
}
